import React from 'react';
import { FileText, Globe, Languages, MessageSquare } from 'lucide-react';

const OutputTypesSection = () => {
  const outputs = [
    {
      title: "프리미엄 이력서 템플릿",
      subtitle: null,
      icon: FileText,
      colorClass: "orange"
    },
    {
      title: "영문 이력서",
      subtitle: null,
      icon: Languages,
      colorClass: "blue"
    },
    {
      title: "JD 맞춤 자소서",
      subtitle: null,
      icon: MessageSquare,
      colorClass: "green"
    },
    {
      title: "개인 웹페이지",
      subtitle: null,
      icon: Globe,
      colorClass: "purple"
    }
  ];

  return (
    <section className="outputs-section">
      <div className="container">
        <div className="section-title">
          <h2>한 번의 대화 = 네 개의 결과물</h2>
        </div>
        
        <div className="outputs-grid-2x2">
          {outputs.map((output, index) => (
            <div key={index} className="output-card-modern">
              <div className="output-preview">
                {index === 0 ? (
                  <img 
                    src="/images/template.png" 
                    alt="PDF 이력서 템플릿 미리보기" 
                    className="template-preview-image"
                  />
                ) : index === 1 ? (
                  <img 
                    src="/images/eng.png" 
                    alt="영어 이력서 미리보기" 
                    className="template-preview-image"
                  />
                ) : index === 2 ? (
                  <img 
                    src="/images/coverletter.png" 
                    alt="JD 맞춤 자소서 미리보기" 
                    className="template-preview-image"
                  />
                ) : index === 3 ? (
                  <img 
                    src="/images/webpage.png" 
                    alt="개인 웹페이지 미리보기" 
                    className="template-preview-image webpage-preview"
                  />
                ) : null}
              </div>
              <p className="output-title-modern">
                {output.title}
                {output.subtitle && (
                  <span className="output-subtitle">{output.subtitle}</span>
                )}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default OutputTypesSection;
